export default __webpack_public_path__ + "static/mobilebg-3e8536925f1ab8c1ef1fa1b794c2fcc3.mp4";